
import { Camera, Loader2 } from "lucide-react";
import { PhotoUploadController } from "@/components/photo/PhotoUploadController";
import PhotoAvatarRow from "@/components/photo/PhotoAvatarRow";
import ProfileImageCropper from "@/components/photo/ProfileImageCropper";
import { PhotoUploadSuccessModal } from "@/components/photo/PhotoUploadSuccessModal";

interface PhotoUploadProps {
  photos: string[];
  onPhotosChange: (photos: string[]) => void;
  maxPhotos?: number;
}

export const PhotoUpload = ({ photos, onPhotosChange, maxPhotos = 5 }: PhotoUploadProps) => {
  const handleSetMainPhoto = (index: number) => {
    if (index === 0) return; // Already main photo
    
    // Move the selected photo to the front (main position)
    const newPhotos = [...photos];
    const selectedPhoto = newPhotos.splice(index, 1)[0];
    newPhotos.unshift(selectedPhoto);
    onPhotosChange(newPhotos);
  };

  return (
    <PhotoUploadController
      photos={photos}
      onPhotosChange={onPhotosChange}
      maxPhotos={maxPhotos}
    >
      {({
        handleFileSelectWithCrop,
        handleEditPhoto,
        handleDragOver,
        handleDrop,
        isProcessing,
        canAddMore,
        uploading,
        fileInputRef,
        openFileDialog,
        handleRemovePhoto,
        cropperProps,
        successModalProps
      }) => (
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            {isProcessing && (
              <div className="flex items-center text-sm text-ice-white/70">
                <Loader2 className="w-4 h-4 animate-spin mr-2" />
                Processing...
              </div>
            )}
          </div>
          
          {/* Avatar Row Layout */}
          <div className="space-y-4">
            {photos.length > 0 ? (
              <div>
                <PhotoAvatarRow
                  photos={photos}
                  onSetMainPhoto={handleSetMainPhoto}
                  onRemovePhoto={handleRemovePhoto}
                  onAddPhoto={openFileDialog}
                  uploading={uploading}
                  canAddMore={canAddMore}
                  disabled={isProcessing}
                />
              </div>
            ) : (
              <div>
                <PhotoAvatarRow
                  photos={[]}
                  onSetMainPhoto={handleSetMainPhoto}
                  onRemovePhoto={handleRemovePhoto}
                  onAddPhoto={openFileDialog}
                  uploading={uploading}
                  canAddMore={canAddMore}
                  disabled={isProcessing}
                />
              </div>
            )}
          </div>
          
          <input
            ref={fileInputRef}
            type="file"
            accept="image/jpeg,image/jpg,image/png,image/webp,image/heic,image/heif,.heic,.heif"
            multiple
            className="hidden"
            onChange={(e) => handleFileSelectWithCrop(e.target.files)}
            disabled={isProcessing}
          />
          
          
          
          <ProfileImageCropper
            isOpen={cropperProps.cropperOpen}
            onClose={cropperProps.onClose}
            onCropComplete={cropperProps.onCropComplete}
            imageFile={cropperProps.imageToEdit}
          />

          <PhotoUploadSuccessModal
            isOpen={successModalProps.showSuccessModal}
            onClose={() => successModalProps.setShowSuccessModal(false)}
            uploadCount={successModalProps.uploadCount}
          />
        </div>
      )}
    </PhotoUploadController>
  );
};
